module.exports = __webpack_public_path__ + "img/40_38_036_740.a0697bb4.jpg";